import { useFont } from '@octane/spark'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 0px 0px 0px 17px;
    height: 60px;
`

export const MainText = styled.p<{
    isWhiteVersion?: boolean
}>`
    ${({ isWhiteVersion, theme }) => css`
        color: ${isWhiteVersion
            ? theme.colors.brand.primary
            : theme.colors.monochrome.white};
    `}

    ${() => useFont('c12', { weight: '700' })}
    margin: 0 0 3px 0;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const PhoneNumber = styled.p<{
    isWhiteVersion?: boolean
}>`
    ${({ isWhiteVersion, theme }) => css`
        color: ${isWhiteVersion
            ? theme.colors.brand.primary
            : theme.colors.monochrome.white};
    `}

    ${() => useFont('c12', { weight: '400' })}
    margin: 0;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
